var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpcpMss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 159,
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6454_180180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.4999 158.5C123.13 158.5 158.5 123.13 158.5 79.4999C158.5 35.8694 123.13 0.5 79.4999 0.5C35.8694 0.5 0.5 35.8694 0.5 79.4999C0.5 123.13 35.8694 158.5 79.4999 158.5Z",
    fill: "#E06993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.496 79.4998C158.496 78.7215 158.482 77.9469 158.459 77.1742L131.031 49.7461L79.496 19.9922L27.9609 49.7461V109.254L77.1704 158.463C77.9432 158.486 78.718 158.5 79.496 158.5C123.127 158.5 158.496 123.13 158.496 79.4998Z",
    fill: "#AB4267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.031 109.254L79.496 139.007L27.9609 109.254V49.7461L79.496 19.9922L131.031 49.7461V109.254Z",
    fill: "#00D4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.035 49.7457V109.254L79.5 139.008V19.9915L131.035 49.7457Z",
    fill: "#009CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9609 49.7463L79.496 79.5V139.008L27.9609 109.254V49.7463Z",
    fill: "#FEE572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.035 49.7463L79.5 79.5V139.008L131.035 109.254V49.7463Z",
    fill: "#0A2A58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6454_180180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 158,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcpMss);
export default __webpack_public_path__ + "static/media/UPCP_MSS.90376fe21e0a9c16275112dbff3fd6d3.svg";
export { ForwardRef as ReactComponent };